import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { CatalogAccessSettingsView } from '@webapp/modules/purchasing/feature-sets/CatalogAccessSettingsView'
import messages from './messages'

export const CatalogItemAccessPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.catalogItemAccessTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('CatalogItemAccessPage', { tab: 'users' }),
          name: intl.formatMessage(messages.catalogItemAccessTitle),
        },
      ]}
    >
      <CatalogAccessSettingsView />
    </Page>
  )
}
